import { api } from '@shared/api/api';

type TrackedJob = App.Domain.TrackedJobs.Data.TrackedJobData;

export const getTrackedJob = (uuid: string) => api.get<TrackedJob>(`tracked-jobs/${uuid}`);
